let stripePromise

export const getStripe = () => {
  if (!stripePromise) {
    stripePromise = import('@stripe/stripe-js').then(({loadStripe}) =>
      loadStripe(process.env.REACT_APP_STRIPE_PUBLIC_KEY)
    )
  }

  return stripePromise
}